import React, { useRef, useCallback, useState } from 'react'
import List from '../grid.component';
import { DateColumnHandler, NumberFormatter, StatusColumnHandler, TransactionsIdColumnHandler } from './service';
import { badge } from 'src/utils/statusColorsCode';

const renderNumberColumn = (key) => (cellProps) => {
  const value = cellProps?.dataItem?.[key] || "0";
  return <NumberFormatter value={value} />;
};

const CardTransactionsGrid = ((props) => {
  const gridRef = useRef(null);
  const [checkboxSelection, setCheckboxSelection] = useState([]);
  const [checkBoxData, setCheckBoxData] = useState({})
  const [copiedId, setCopiedId] = useState('');

  const handleIdCopy = useCallback((id) => {
    setCopiedId(id);
    setTimeout(() => {
      setCopiedId('');
    }, 300)
  }, [])

  const handleCheckboxChanges = useCallback(
    (prop, e) => {
      props?.handleError(null);
      if (e.target.checked) {
        const rowChecked = prop.dataItem;
        let _selection = [...checkboxSelection];
        let idx = _selection.indexOf(rowChecked.transactionId);
        if (checkboxSelection) {
          _selection = [];
        }
        if (idx > -1) {
          _selection.splice(idx, 1);
        } else {
          _selection.push(rowChecked.transactionId);
        }
        setCheckBoxData(rowChecked);
        setCheckboxSelection(_selection);
        props.setSelectedTransaction(rowChecked)
      } else {
        setCheckBoxData({});
        setCheckboxSelection([]);
        props.setSelectedTransaction({})
      }
    }, [checkboxSelection]);

  const dateColumnHandler = (props) => { return (<DateColumnHandler data={props} />) }
  const statusColumnHandler = (props) => { return (<StatusColumnHandler data={props} badge={badge} />) }
  const idColumnHandler = (props) => { return (<TransactionsIdColumnHandler data={props} copiedId={copiedId} handleIdCopy={handleIdCopy} />) }

  const renderCustomCell = useCallback((transcationProps, column) => {
    const customCells = {
      "transactionId": idColumnHandler,
      "status": statusColumnHandler,
      "applyTime": dateColumnHandler,
      "amount": renderNumberColumn("amount"),
      "fee": renderNumberColumn("fee"),
      "walletBefore": renderNumberColumn("walletBefore"),
      "walletAfter": renderNumberColumn("walletAfter"),
      "beforeAmount": renderNumberColumn("beforeAmount"),
      "afterAmount": renderNumberColumn("afterAmount"),
    }
    if (customCells[column.field])
      return customCells[column.field](transcationProps);
  }, [copiedId])

  return (
    <div>
      <List
        url={process.env.REACT_APP_GRID_API + `api/CardsManageService/CardManage/Transactions`}
        additionalParams={props?.filterValues}
        pSize={10}
        className="custom-grid"
        ref={gridRef}
        showExcelExport={props?.isExcelExport}
        pKey={"Transactions"}
        screenName={"Transactions"}
        renderCustomCell={renderCustomCell}
        handleSelection={handleCheckboxChanges}
        showGridSelection={true}
        selection={[checkBoxData?.transactionId]}
      />
    </div>
  )
})
export default React.memo(CardTransactionsGrid)
